import AuthService, { loginEvent } from '../services/authentication'
import Axios from 'axios'

export default {
  install (Vue: any) {
    Vue.prototype.$auth = AuthService

    Vue.mixin({
      created () {
        if (this.handleLoginEvent) {
          AuthService.addListener(loginEvent, this.handleLoginEvent)
        }
      },
      destroyed () {
        if (this.handleLoginEvent) {
          AuthService.removeListener(loginEvent, this.handleLoginEvent)
        }
      }
    })
  }
}

// Whitelist containing URLs of hosts that need the Authorization header
const authHostUrlWhitelist: string[] = []

// Add a host url into the whitelist
export function registerUrl (url: string) {
  if (!url.endsWith('/')) {
    url += '/'
  }
  authHostUrlWhitelist.push(url)
}

// Validate if a host url is within the whitelist
function isAuthHostUrl (url: string | undefined): boolean {
  if (!url) {
    return false
  }
  for (const hostUrl of authHostUrlWhitelist) {
    if (url.startsWith(hostUrl)) {
      return true
    }
  }
  return false
}

Axios.interceptors.request.use((config) => {
  // Add authentication headers before request is sent
  if (isAuthHostUrl(config.url)) {
    return AuthService.headers().then((headers) => {
      Object.entries(headers).forEach(([key, value]) => {
        if (config.headers[key] === undefined) {
          config.headers[key] = value
        }
      })
      return config
    })
  }
  return config
}, (error) => {
  // Might want to do something with request error
  return Promise.reject(error)
})
